export const RE_INITIALIZE_ON_EMBED_ADD = false;
export const FILTER_INPUT_SEPARATOR = '|';